// @flow
import {connect} from 'react-redux';
// import {bindActionCreators} from 'redux';
import MultiChat from '../components/MultiChat/MultiChat';

import type {RootState} from '../../..';
// import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
  }),
  null
)(MultiChat);
